import { meetingsActions } from '@lifesize/nucleus';
import { PayloadAction } from '@lifesize/typescript-react-redux-utils/src/createAction';
import _get from 'lodash/get';
import _set from 'lodash/set';
import { Dispatch, Middleware, MiddlewareAPI } from 'redux';
import { MaxInactiveDaysActions, actions } from '../actions/maxInactiveDaysActions';
import { actions as ModalActions } from '../actions/modalActions';
import { ModalTypes } from 'constants/modalConstants';
import listInactiveMeetingsQuery from 'queries/meetings/listInactiveMeetingsQuery.gql';
import { getClient } from '../nucleus-apollo-client';
import { Meeting } from '../typings/types';
import moment from 'moment';

const updateNumberOfDaysBeforeExpiration = async (requestedNumberOfDays: number, dispatch: Function) => {
  await dispatch(meetingsActions.putMeetingsMaxInactiveDays(requestedNumberOfDays));
};

const meetingsMiddleware =
  (store: MiddlewareAPI) => {
    return (dispatch: Dispatch) => {
      return async (action: PayloadAction<string, object>) => {

        switch (action.type) {
          case MaxInactiveDaysActions.GET_INACTIVE_DAYS:
            await dispatch(meetingsActions.resetMeetingErrorState());
            return store.dispatch(meetingsActions.getMeetingsMaxInactiveDays());
          case MaxInactiveDaysActions.GET_ITEMS_TO_BE_DELETED:
            await dispatch(actions.setBusyFetchingMeetingsToDelete());
            const requestedNumberOfDays = _get(action.payload, 'requestedNumberOfDays', 0);
            if (requestedNumberOfDays === 0) {
              // Just save the change of days to expiration - no modal needed.
              await updateNumberOfDaysBeforeExpiration(0, dispatch);
              return await dispatch(actions.setNotBusyFetchingMeetingsToDelete());
            }
            // If # of days > 0, check to see if any meetings need deletion
            const client = await getClient(window.store as Dispatch);
            const endDate = moment().subtract(requestedNumberOfDays, 'days');
            const response = await client.query({
              query: listInactiveMeetingsQuery,
              fetchPolicy: 'no-cache',
              // Queries from epoch 1/1/1970, to today minus new # of days
              variables: { endDate: endDate.format('YYYY-MM-DD'), sortField: 'displayName' }
            });
            const records = _get(response, 'data.directoryListMeetingsMultiField.records', []);
            const toBeDeleted = records.filter((o: Meeting) => {
              return o.lastUsedAt !== null && endDate.isSameOrAfter(moment(o.lastUsedAt));
            });

            if (toBeDeleted.length) {
              // If here - a list of meetings that will be deleted is returned
              await dispatch(actions.setNotBusyFetchingMeetingsToDelete());
              _set(action.payload, 'itemsToBeDeleted', toBeDeleted);
              dispatch(
                ModalActions.openModal({
                  modalType: ModalTypes.MEETINGS_CONFIRM_EXPIRATION_DELETE,
                  payload: action.payload
                }),
              );
              return;
            }
            // If here, no modal needed, there are no meetings to be deleted
            // Just update the # of days before expiration
            await dispatch(actions.setNotBusyFetchingMeetingsToDelete());
            return await updateNumberOfDaysBeforeExpiration(requestedNumberOfDays, dispatch);

          default:
            return dispatch(action);
        }
      };
    };
  };

export default (meetingsMiddleware as Middleware);
